import { Injectable, inject } from '@angular/core';

import { ModalService } from './modal.service';
import { ModalImageCropperComponent } from '~/app/shared/modals/modal-image-cropper/modal-image-cropper.component';

@Injectable({
    providedIn: 'root',
})
export class ModalImageCropperService {
    private modal = inject(ModalService);


    public open(file: File) {
        return this.modal.open<File | null, { file: File }>(ModalImageCropperComponent, {
            file,
        });
    }
}
